/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offline_Mode_BannerInputs */



/**
* | output |
* | --- |
* | "OFFLINE MODE — Changes are stored locally" |
*
* @param {Offline_Mode_BannerInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const offline_mode_banner = /** @type {((inputs?: Offline_Mode_BannerInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_Mode_BannerInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("MODE HORS LIGNE — Les modifications sont stockées localement")
	if (locale === "es") return /** @type {LocalizedString} */ ("MODO SIN CONEXIÓN — Los cambios se guardan localmente")
	if (locale === "pt") return /** @type {LocalizedString} */ ("MODO OFFLINE — As alterações são armazenadas localmente")
	if (locale === "it") return /** @type {LocalizedString} */ ("MODALITÀ OFFLINE — Le modifiche sono salvate localmente")
	return /** @type {LocalizedString} */ ("OFFLINE MODE — Changes are stored locally")
});